export default __webpack_public_path__ + "static/media/header-home.6fa46208.svg";